import { StyledTextLink } from '../../Basic/Link/TextLink/TextLink.styles.mjs';
import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import { StyledText } from '../../Typography/Text/Text.styles.mjs';
import styled from 'styled-components';

const StyledStoryTitleContainer = styled.div `
  ${StyledHeading}, ${StyledText} {
    margin: 0;
  }

  ${StyledTextLink}, ${StyledText} {
    display: inline;
  }
`;

export { StyledStoryTitleContainer };
//# sourceMappingURL=StoryTitle.styles.mjs.map
